import { Invoice } from './billing.model';
import { BillingService } from '@/modules/billing/billing.service';
import { wrapError } from '@/util';
import { patientBffApi } from '@/modules/baseApi';
import { useCurrentHospital } from '@/modules/hospital';

export const billingApi = patientBffApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    invoices: builder.query<Invoice[], void>({
      queryFn: () =>
        BillingService.getInstance()
          .fetchAll()
          .then(({ data }) => ({ data }))
          .catch(wrapError),
      providesTags: ['Invoice']
    }),

    signInvoice: builder.mutation<void, Invoice>({
      queryFn: (invoice) =>
        BillingService.getInstance()
          .sign(invoice)
          .then(() => ({ data: {} as any }))
          .catch(wrapError),
      invalidatesTags: ['Invoice']
    })
  })
});

export const {
  useInvoicesQuery: useInvoices,
  useSignInvoiceMutation: useSignInvoice
} = billingApi;

export const useIsBillingEnabledOnHospital = () => {
  const {
    queryResult: { data: hospital }
  } = useCurrentHospital();
  return !!hospital?.billingModuleEnabled;
};
